import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ModelMolecule from '@models/molecule'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'
import { Pawn } from '@/services/store/types'
import moleculePawn from './pawn/index.vue'
import { PawnDragEvent, PawnDroppedEvent } from '@/interfaces/events'
import { globalEvents } from '@/constants/events'
import MixinFats from '@/mixins/fats'

@Component({
  components: {
    'vgb-molecule-pawn': moleculePawn,
  },
  filters: {
    encircle(value: string) {
      return value.replace(/ⓟ/i, '<span class="encircled">P</span>')
    },
  },
})
export default class Molecule extends mixins(MixinGame, MixinFats) {

  get formula(): string {
    return this.formulaLocal
  }

  get subTitle() {
    return this.subTitleLocal
  }

  get isFormulaVisible() {
    return this.model.hasFormula
  }

  get isTitleVisible() {
    return !this.isFormulaVisible ||
      this.isFattyAcid ||
      this.isCoa
  }

  get isSubTitleVisible() {
    return this.isFattyAcid
  }

  get styleObject(): object {
    return {
      top: `${this.model.position.top}px`,
      left: `${this.model.position.left}px`,
    }
  }

  get isFattyAcid() {
    return this.model.id === '1oxv7zxd'
  }

  get isCoa() {
    return this.model.id === 'j297dq94'
  }

  get moleculePawns(): Pawn[] {
    return this.pawns
      .filter((pawn: Pawn) => pawn.moleculeID === this.model.id)
  }

  get moleculePawnCount(): number {
    return this.moleculePawns.length
  }

  @Prop() private model: ModelMolecule

  private formulaLocal: string = ''
  private subTitleLocal: string = ''

  @Watch('moleculePawnCount', { immediate: true })
  public onMoleculePawnAmountChange() {
    this.setDefaultFormula()
    this.setDefaultTitle()
  }

  public onPawnDragOverMolecule(event: PawnDragEvent) {
    this.setActiveFormula(event.chainLength)
    this.setActiveSubTitle(event.chainLength, event.doubleBinding)
  }

  public onPawnDragOutMolecule() {
    this.setDefaultFormula()
    this.setDefaultTitle()
  }

  public created() {
    this.setDefaultFormula()
    this.setDefaultTitle()

    this.$bus.$on(globalEvents.PAWN_DROPPED_ON_MOLECULE, (event: PawnDroppedEvent) => {
      if (event.molecule.id === this.model.id) {
        this.setActiveFormula(event.chainLength)
      }
    })
  }

  private setDefaultTitle() {
    if (this.isFattyAcid) {
      this.subTitleLocal = '(o.a.  lauraat, stearaat, oleaat, palmitaat)'
    }
  }

  private setActiveSubTitle(chainLength: number, doubleBinding: number | undefined) {
    if (chainLength !== 0) {
      this.subTitleLocal = this.fatGetTitle(chainLength, doubleBinding as number)
    }
  }

  private setDefaultFormula() {
    if (this.model.hasFormula) {
      this.formulaLocal = this.model.defaultFormula as string
    }
  }

  private setActiveFormula(chainLength: number) {
    if (this.model.hasActiveFormula) {
      switch (chainLength) {
        case 6:
          this.formulaLocal = this.model.c6Formula as string
          break
        case 4:
          this.formulaLocal = this.model.c4Formula as string
          break
        case 2:
          this.formulaLocal = this.model.c2Formula as string
          break
        default:
          let formula = this.model.activeFormula as string
          let minus = 4

          if (this.model.title === 'right-0') {
            minus = 2
          }

          const char = [
            '\u2080',
            '\u2081',
            '\u2082',
            '\u2083',
            '\u2084',
            '\u2085',
            '\u2086',
            '\u2087',
            '\u2088',
            '\u2089'][(chainLength - minus) / 2]

          formula = formula.replace('X', char)
          this.formulaLocal = formula
      }
    }
  }
}
